export default __webpack_public_path__ + "static/media/cover.c384664b.jpg";